import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Host-agnostic Kirigami wordmark. Self-styled via inline CSS so it renders
 * identically in Tailwind-aware hosts (apps/web-console) and Tailwind-free
 * hosts (apps/kirigami-app).
 */
@Component({
  selector: 'kirigami-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        color: inherit;
      }
      .k-logo-wordmark {
        display: none;
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.3;
        letter-spacing: -0.01em;
        color: inherit;
      }
      @media (min-width: 690px) {
        .k-logo-wordmark {
          display: inline-flex;
        }
      }
    `,
  ],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" aria-hidden="true">
      <g clip-path="url(#kirigami-logo-clip)">
        <path
          fill="#4D8CB9"
          fill-rule="evenodd"
          d="M32 .43c0 2.204-.437 4.363-1.262 6.361v.132h-.055a16.648 16.648 0 0 1-3.553 5.28h-.002l-.072.073a16.623 16.623 0 0 1-5.804 3.727 16.624 16.624 0 0 1 5.787 3.72v.001h.001l.072.073a16.65 16.65 0 0 1 3.554 5.28h.055v.132a16.665 16.665 0 0 1 1.262 6.361V32h-9.69v-.003a16.618 16.618 0 0 1-11.407-4.8l-.002-.002-.07-.07-.002-.002a16.642 16.642 0 0 1-3.016-4.135v5.114a3.898 3.898 0 1 1-7.796 0V3.898a3.899 3.899 0 0 1 7.796 0v5.147a16.643 16.643 0 0 1 3.033-4.168l.001-.001.072-.071v-.002A16.619 16.619 0 0 1 22.31.003V0H32v.43ZM9.823 21.266c.73 1.9 1.975 3.446 3.292 4.626l.037.033-.005.001a14.146 14.146 0 0 0 9.424 3.598h.098l.098-.002.434-.005v.007h6.16a14.186 14.186 0 0 0-.432-1.971h-6.182v-.002a16.611 16.611 0 0 1-7.673-2.025l-.014.003-.008-.004c-.508-.28-.98-.577-1.42-.883a16.62 16.62 0 0 1-1.789-1.415c-.79-.702-1.45-1.387-2.02-1.96Zm1.214-2.614a14.806 14.806 0 0 0 2.938 3.151 14.147 14.147 0 0 0 9.05 3.274h.098l.098-.001.435-.006v.007h4.28a14.162 14.162 0 0 0-1.227-1.97H23.43l.01-.012c-6.581-.015-10.844-2.81-12.404-4.443Zm2.028-1.256a14.146 14.146 0 0 0 9 3.235l.1-.001.097-.001.435-.006v.008h1.657a14.145 14.145 0 0 0-8.835-3.234h-2.454Zm9.649-6.019-.435-.006-.098-.001h-.098a14.146 14.146 0 0 0-9 3.234h1.809v-.002l.43.001H15.536a14.146 14.146 0 0 0 8.836-3.234h-1.658v.008Zm.328-4.454a14.146 14.146 0 0 0-9.05 3.274l-.195.16a14.802 14.802 0 0 0-2.743 2.99c1.56-1.631 5.823-4.427 12.404-4.442l-.01-.012h3.278c.464-.624.875-1.283 1.228-1.97h-4.281v.007l-.435-.006-.098-.001h-.098Zm.177-4.44-.435-.005-.098-.001-.098-.001a14.146 14.146 0 0 0-9.424 3.598h.006l-.038.034c-1.316 1.18-2.563 2.725-3.293 4.626.57-.574 1.231-1.259 2.021-1.961a16.624 16.624 0 0 1 1.788-1.415c.44-.306.913-.603 1.421-.883l.008-.004.013.003a16.613 16.613 0 0 1 7.675-2.025v-.002h6.181c.19-.644.335-1.303.433-1.971h-6.16v.007Z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="kirigami-logo-clip"><path fill="#fff" d="M0 0h32v32H0z" /></clipPath>
      </defs>
    </svg>
    <span class="k-logo-wordmark">Kirigami</span>
  `,
})
export class KirigamiLogo {}
